import Link from 'next/link';
import { Chip, Tooltip, Typography } from 'src/components/PulseUI';
import React from 'react';

interface TagData {
  id?: number;
  name?: string;
  label?: string;
  FormattedText?: () => React.JSX.Element;
  fullText?: string;
  bgColor?: string;
  bg_color?: string;
  color?: string;
  taggable_type?: string;
  href?: string;
}

interface TagProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'size'> {
  tag: TagData;
  size?: 'small' | 'medium';
}

const Tag: React.FC<TagProps> = ({ tag, size, ...props }) => {
  const tagLabel = tag.label || tag.name || '';
  const displayText = tag.FormattedText ? (
    <tag.FormattedText />
  ) : (
    <Typography variant="body2" className="text-xs uppercase">
      {tag.name}
    </Typography>
  );
  const fullName = tag.fullText || tagLabel;
  const chipSize: 'sm' | 'md' | 'lg' = size === 'small' ? 'sm' : 'md';

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { color, ...restProps } = props;

  const renderChip = () => (
    <Tooltip content={fullName}>
      <Chip
        {...restProps}
        size={chipSize}
        variant="soft"
        color="neutral"
        className="max-w-full"
        role="status"
        aria-label={`Tag: ${tagLabel}`}
        data-testid={`tag-chip-${tag.id ?? tagLabel}`}
      >
        {displayText}
      </Chip>
    </Tooltip>
  );

  if (!tag.taggable_type && tag.href) {
    return (
      <Link
        href={tag.href}
        aria-label={`Navigate to ${tagLabel}`}
        className="max-w-full inline-block"
        data-testid={`tag-link-${tag.id ?? tagLabel}`}
      >
        {renderChip()}
      </Link>
    );
  }

  return renderChip();
};

export default Tag;
